import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

/** Indicateur d'en-tête des onglets de la fiche véhicule. */
export const SummaryTile = ({ label, value, sub, loading }: { label: string; value: string; sub?: string; loading?: boolean }) => (
  <Card>
    <CardContent className="p-4">
      <p className="text-sm text-muted-foreground">{label}</p>
      {loading ? <Skeleton className="h-7 w-24 mt-1" /> : <p className="text-2xl font-bold tabular-nums">{value}</p>}
      {sub && !loading && <p className="text-xs text-muted-foreground">{sub}</p>}
    </CardContent>
  </Card>
);
